import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { fabric } from 'fabric';
import _ from 'lodash';
import { Subscription } from "rxjs";
import { ActivitiesService } from "src/app/activities/activities.service";
import { LayoutService } from "src/app/layout/layout.service";
import { ShapeTypeEnum } from "src/app/shared/constants/commonenums";
import { urlConfig } from "src/app/shared/constants/url-config";
import { InputImages } from "src/app/shared/dynamicform/models/common-models";
import { GuestService } from "src/app/shared/services/guest.service";
import { HttpService } from "src/app/shared/services/http.service";
import { ActivatedRoute } from "@angular/router";
import { ReservationService } from "src/app/layout/reservation.service";
import { ActivitiesLayoutSupportService } from "./activities-layout-support.component";

@Component({
    selector: 'activities-layout',
    templateUrl: './activities-layout.component.html',
    styleUrls: ['./activities-layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ActivitiesLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input('floorPlan') floorPlanData;
    @Input('currentBookingSize') currentBookingSize;
    @Input() seatingTypeList;
    @Input('selectedSeatingType')
    set selectedSeatingType(id: number) {
        this._selectedSeatingType = id;
        if (this._selectedSeatingType && this.canvas) {
            this.highlightByTypeHandler();
        }
    }
    @Input('updateIndicator') 
    set updateIndicator(indicator){
        if(this.canvas){
            this.updateLocationSelection();
        }
    }
    @Output('locationSelection') locationSelection = new EventEmitter();

    _selectedSeatingType;
    _selectedLocations;
    subscriptions: Subscription = new Subscription();
    dataToBePushed = [];
    canvas: any;
    topMinValue: any;
    leftMinValue: any;
    heightValue;
    widthValue;
    @ViewChild('canvasLoader') canvasLoader: ElementRef;
    scaleFactorY = 1;
    scaleFactorX = 1;
    customImages: InputImages[] = [];
    layoutImages: InputImages[] = [];
    objectImages: InputImages[] = [];
    shapeTypeEnum = {
        0: 'rect',
        1: 'circle',
        2: 'pin'
    };
    selectedTableIds = [];
    tableObj: any = []
    rectangle: any;
    circle: any;
    ellipse: any;
    pin: any;
    basicRectangle: fabric.Rect;
    basicCircle: fabric.Circle;
    layoutStyle: { width: string, height: string } = null;
    masterStatusData: any = {};

    // selectedItems = [];
    
    locationDetail: {
        MinPartySize: number,
        MaxPartySize: number,
        Name: string,
        position: any,
        availability: 'available' | 'notAvailable' 
        Price: string
    }

    
    @Input() currentFromDate;
    @Input() matchedContinousSlots;
    @Input() duration;
    @Input() sizeMapping;
    @Input() restaurantId;

    constructor(private httpService: HttpService, public guestService: GuestService, private activitiesService: ActivitiesService, public route: ActivatedRoute, public rs: ReservationService, public rateplanSupportService: ActivitiesLayoutSupportService) {
        
    }

    initData(): void {
        this.masterStatusData = {
            soldout: {
                textColor: '#989898',
                stroke: '#d3d3d3',
                text: '\u20E0',
                fill: '#d3d3d3'
            },
            notSelectable: {
                textColor: '#ffffff',
                stroke: '#000000',
                text: '\u002B',
                fill: '#000000'
            },
            selectable: {
                textColor: this.getButtonColor()[0],
                stroke: this.getButtonColor()[0],
                text: '\u002B',
                fill: this.getButtonColor()[1]
            }
        }
    }

    zoomtoFit() {
        setTimeout(() => {
            this.canvas.zoomToPoint({ x: 300, y: 100 }, this.canvas.getZoom() * 0.9);
            console.log("ZoomValue: ", this.canvas.getZoom())
        }, 0)
    }

    highlightByTypeHandler(loopCount = 1, seatingTypeSelected?) {
        if (!seatingTypeSelected) {
            seatingTypeSelected = this.seatingTypeList.find(x => x.Id == this._selectedSeatingType);
        }
        let color;
        if (seatingTypeSelected) {
            let statusColor = seatingTypeSelected.Color;
            color = 'rgba(' + statusColor.R + ',' + statusColor.G + ',' + statusColor.B + ',' + statusColor.A + ')';
        }
        if(!this._selectedSeatingType){
            this.highlightByTypeAction(seatingTypeSelected, false, color);   
            loopCount = 8; // Break highlight loop     
        }else{
            this.highlightByTypeAction(seatingTypeSelected, (loopCount % 2), color);
        }


        loopCount += 1;
        setTimeout(() => {
            if (loopCount < 7) {
                this.highlightByTypeHandler(loopCount, seatingTypeSelected);
            }
        }, 500);
    }

    highlightByTypeAction(seatingTypeSelected, isHighlight, color = highlightColor) {
        this.canvas._objects.forEach(element => {
            if ((element.SeatingTypeId === this._selectedSeatingType 
                || !isHighlight || (this._selectedSeatingType && element.SeatingTypeId !== this._selectedSeatingType))
                && element.IsAvailableForBooking && element.IsAvailableForReservations) {
                    let fillColor;
                    if(isHighlight && element.SeatingTypeId === this._selectedSeatingType){
                        fillColor = highlightColor;
                    }else{
                        fillColor = element.isSelected ?  defaultTheme : element.tableColor
                    }
                element._objects.filter(x => (element.ShapeType === 2 && x.name == 'shape')
                || (element.ShapeType !== 2 && x.name == 'textCircle'))[0].set({
                    fill: fillColor
                });
            }
        });
        this.canvas.renderAll();
    }

    setColorByType(element){
        let seatingTypeSelected = this.seatingTypeList.find(x => x.Id == this._selectedSeatingType);
        
        let color;
        if (seatingTypeSelected) {
            let statusColor = seatingTypeSelected.Color;
            color = 'rgba(' + statusColor.R + ',' + statusColor.G + ',' + statusColor.B + ',' + statusColor.A + ')';
        }

    }

    updateLocationSelection(){
        let selectedIds = this.guestService.selectedNonDiningLocation?.length ? this.guestService.selectedNonDiningLocation.map(({Id}) => Id) : [];
        this.canvas._objects.forEach(element => {
            if (selectedIds.includes(element.Id)) {
                element.isSelected = true;
                this.highlightSelectedObject(element);
            }else if(element.isSelected){
                element.isSelected = false;
                this.removeHighlightSelectedObject(element);
            }
        });
        this.canvas.renderAll();
    }

    zoomSubs() {
        this.zoomtoFit();
        let _that = this;
        this.canvas.on('mouse:wheel', (opt) => {
            var evt = opt.e;
            if (evt.ctrlKey === true) {
                var delta = opt.e.deltaY;
                var zoom = this.canvas.getZoom();
                opt.e.preventDefault();
                opt.e.stopPropagation();
                // zoom *= 0.999 ** delta;

                if(delta > 0){
                    zoom /= 1.03;
                }else{
                    zoom *= 1.03;
                }

                let vpt = this.canvas.viewportTransform;
                if (zoom < 0.9) {
                    vpt[4] = 30;
                    vpt[5] = 10;
                    
                    return;
                }
                

                if (zoom > 20) zoom = 20;
                if (zoom < 0.01) zoom = 0.01;

                this.zoomBoundaryHandler(vpt);

                console.log("Touch Points", opt.e.offsetX, opt.e.offsetY);

                this.canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
            }
        });
        let canvaElm = document.getElementById('canvaContainer');
        canvaElm.addEventListener('touchmove', (opt) => {
            // console.log(opt);
            if('[object HTMLCanvasElement]' === opt.target.toString()){
                if(opt.touches.length === 2){
                    let {x: _containerX, y: _containerY} = opt.target?.['getBoundingClientRect']()
                    let _xPoint = ((opt.touches[0].clientX + opt.touches[1].clientX) / 2) - _containerX;
                    let _yPoint = ((opt.touches[0].clientY + opt.touches[1].clientY) / 2) - _containerY;

                    var zoom = this.canvas.getZoom();
                    opt.preventDefault();
                    opt.stopPropagation();

                    console.log("_XPoint, _YPoint", _xPoint, _yPoint);
    
                    let _diffX = (opt.touches[1].screenX - opt.touches[0].screenX);
                    let _diffY = (opt.touches[1].screenY - opt.touches[0].screenY);
                    
                    if(_diffX < 0){
                        _diffX *= -1;
                    }
                    if(_diffY < 0){
                        _diffY *= -1;
                    }

                    if(!this.canvas.lastTouchDiff || (_diffX > this.canvas.lastTouchDiff.x) || (_diffY > this.canvas.lastTouchDiff.y)){
                        zoom *= 1.03;
                    }else{
                        zoom /= 1.03;
                    }
                    this.canvas.lastTouchDiff = {
                        x: _diffX,
                        y: _diffY
                    };
                    
                    let vpt = this.canvas.viewportTransform;
                    if (zoom < 0.9) {
                        vpt[4] = 30;
                        vpt[5] = 10;
                        
                        return;
                    }
                    
                    if (zoom > 20) zoom = 20;
                    if (zoom < 0.01) zoom = 0.01;

                    this.zoomBoundaryHandler(vpt);

                    this.canvas.intialZoomPoint = { x: _xPoint, y: _yPoint };
                    
                    this.canvas.zoomToPoint(this.canvas.intialZoomPoint || { x: _xPoint, y: _yPoint }, zoom);
                }
            }
        })

        canvaElm.addEventListener('touchend', (opt) => {
            this.canvas.lastTouchDiff = null;
            this.canvas.intialZoomPoint = null;
        })

        this.canvas.on('mouse:over', (opt) => {
            // this.showLocationDetails(opt);            
        });
        this.canvas.on('mouse:move', (opt) => {
            // if(!(opt.target && (opt.target.ShapeType === 2 ||  opt.target.ShapeType === 3))){
            //     this.locationDetail = null;
            // }
            if (this.canvas.isDragging) {
                var e = opt.e;
                var vpt = this.canvas.viewportTransform;

                let _expectedXPosition;
                let _expectedYPosition;
                let _eClientX;
                let _eClientY;
                
                if(e.type === 'mousemove'){
                    _expectedXPosition = vpt[4] + e.clientX - this.canvas.lastPosX;
                    _expectedYPosition = vpt[5] + e.clientY - this.canvas.lastPosY;

                    _eClientX = e.clientX;
                    _eClientY = e.clientY;
                }
                if(e.type === 'touchmove' && e.touches && e.touches.length === 1){
                    _expectedXPosition = vpt[4] + e.touches[0].clientX - this.canvas.lastPosX;
                    _expectedYPosition = vpt[5] + e.touches[0].clientY - this.canvas.lastPosY;
                    this.canvas.requestRenderAll();

                    _eClientX = e.touches[0].clientX;
                    _eClientY = e.touches[0].clientY;

                    
                }

                /** Allow Move by Postion */

                let _canvasZoom = this.canvas.getZoom();

                let _maxAllowed = {
                    left: -1 * this.canvas.width * (_canvasZoom - 1),
                    top: -1 * this.canvas.height * (_canvasZoom - 1)
                }

                let allowXMove = (_expectedXPosition < 30 || vpt[4] > 30 && vpt[4])
                         && (_maxAllowed.left < _expectedXPosition);
                let allowYMove = (_expectedYPosition < 10 || vpt[5] > 10)
                         && (_maxAllowed.top < _expectedYPosition);

                if(allowXMove){
                    vpt[4] = _expectedXPosition;
                }
                if(allowYMove){
                    vpt[5] = _expectedYPosition;
                }

                this.canvas.requestRenderAll();

                if(allowXMove){
                    this.canvas.lastPosX = _eClientX;
                }
                if(allowYMove){
                    this.canvas.lastPosY = _eClientY;
                }

                // if(_expectedXPosition && _expectedYPosition){
                //     vpt[4] = _expectedXPosition;
                //     vpt[5] = _expectedYPosition;
                //     this.canvas.requestRenderAll();
                //     this.canvas.lastPosX = _eClientX;
                //     this.canvas.lastPosY = _eClientY;
                // }
            }
        });
        this.canvas.on('mouse:up', function (opt) {
            // on mouse up we want to recalculate new interaction
            // for all objects, so we call setViewportTransform
            this.setViewportTransform(_that.canvas.viewportTransform);
            _that.canvas.isDragging = false;
            _that.canvas.selection = true;
        });
    }

    zoomBoundaryHandler(vpt){
        if(!vpt){
            vpt = this.canvas.viewportTransform;
        }
        let _canvasZoom = this.canvas.getZoom();
        let _maxAllowed = {
            left: -1 * this.canvas.width * (_canvasZoom - 1),
            top: -1 * this.canvas.height * (_canvasZoom - 1)
        }

        if(vpt[4] > 30){
            vpt[4] = 30;
        }else if(_maxAllowed.left > vpt[4]){
            vpt[4] = _maxAllowed.left
        }
        if(vpt[5] > 10){
            vpt[5] = 10;
        }else if(_maxAllowed.top > vpt[5]){
            vpt[5] = _maxAllowed.top
        }
    }

    showLocationDetails(opt: any){
        if(opt.target && opt.target.Id){
            let bounds = document.getElementsByClassName('tables-layout__canvas-view')[0].getBoundingClientRect();
            let x = opt.e.clientX - bounds.x + 10;
            let y = opt.e.clientY - bounds.y + 30;
            
            if((x + 200) > bounds.width){
                x = x - ((x + 250) - bounds.width);
            }
            if((y + 90) > bounds.height){
                y = y - ((y + 170) - bounds.height);
            }

            let [min, max] = [opt.target.MinPartySize, opt.target.MaxPartySize];
            let availability;
            if(!opt.target.IsAvailableForBooking){
                availability = 'soldOut';
            }else{
                availability = (this.currentBookingSize >= min && this.currentBookingSize <= max 
                    || !this.guestService.validateLocationSize) ? 'available' : 'notAvailable';
            }
            this.locationDetail = {
                MinPartySize: min,
                MaxPartySize: max,
                Name: opt.target.Name,
                position: {
                    left: `${x}px`,
                    top: `${y}px`
                },
                availability,
                Price: opt.target.PriceDetail?.Total || 0,
            }
        }
    }

    ngOnDestroy(): void {

    }

    ngAfterViewInit(): void {
        this.subscriptions.add(this.guestService.restaurantImages.subscribe((images) => {
            if (images && !this.canvas) {
                this.layoutImages = images.LayoutImages;
                this.objectImages = images.ObjectImages;
                this.customImages = images.CustomImages;

                let floorPlanImage = this.layoutImages.filter(x => x.ImageId == this.floorPlanData.ImageId)[0];
                if (floorPlanImage) {
                    this.setLayoutWidth(floorPlanImage);
                }
                this.setCanvas();
                if (this.floorPlanData) {
                    this.setDefaultFloor(this.floorPlanData.StandaloneTables.filter(x => !x.IsTemplate), this.floorPlanData.Labels, this.floorPlanData.Walls, this.floorPlanData.Shapes, this.floorPlanData.ImageId);
                }
                
                if(this.guestService.selectedNonDiningLocation?.length){
                    this.updateLocationSelection();
                }
            }
        }))

    }

    setLayoutWidth(floorPlanImage) {
        fabric.Image.fromURL(floorPlanImage ? 'data:image/png;base64,' + floorPlanImage.bytes : '', (img) => {
            this.layoutStyle = { width: img.width + 'px', height: img.height + 'px' }
        });
    }
    ngOnInit(): void {
        this.initData();
    }


    setDefaultFloor(tables, labels, walls, shapes, imageId) {
        //****this.dataToBePushed = [];
        labels.forEach((element, index) => {
            element.id = index;
            element.name = 'label';
        });
        walls.forEach((element, index) => {
            element.id = index;
            element.name = 'wall';
        });

        shapes.forEach((element, index) => {
            element.id = index;
            element.name = 'area';
        });


        tables = _.cloneDeep(tables);
        labels = _.cloneDeep(labels);
        walls = _.cloneDeep(walls);
        shapes = _.cloneDeep(shapes);
        let basicTables = this.findminObject(tables, labels, walls, shapes);
        let topMinValue = _.minBy(basicTables, 'totalminDataHeight');
        let leftMinValue = _.minBy(basicTables, 'totalminDataWidth');
        const negativeCoords = basicTables.filter(x => x.totalminDataHeight < 0 || x.totalminDataWidth < 0);
        this.topMinValue = Math.abs(topMinValue['totalminDataHeight']);
        this.leftMinValue = Math.abs(leftMinValue['totalminDataWidth']);
        if (negativeCoords.length > 0) {
            // negative values
            let adjustedTopValue = topMinValue['totalminDataHeight'] < 0 ? Math.abs(topMinValue['totalminDataHeight']) : 0;;
            let adjustedLeftValue = leftMinValue['totalminDataWidth'] < 0 ? Math.abs(leftMinValue['totalminDataWidth']) : 0;
            tables.forEach(element => {
                element.Top = element.Top + Math.abs(adjustedTopValue);
                element.Left = element.Left + Math.abs(adjustedLeftValue);
            });
            labels.forEach(element => {
                element.Top = element.Top + Math.abs(adjustedTopValue);
                element.Left = element.Left + Math.abs(adjustedLeftValue);
            });
            walls.forEach(element => {
                element.Points.forEach(point => {
                    point['X'] = point['X'] + adjustedLeftValue;
                    point['Y'] = point['Y'] + adjustedTopValue;
                });
            });

            shapes.forEach(element => {
                element.Top = element.Top + Math.abs(adjustedTopValue);
                element.Left = element.Left + Math.abs(adjustedLeftValue);
            });

            //       // find new min val
            basicTables = this.findminObject(tables, labels, walls, shapes);
            topMinValue = _.minBy(basicTables, 'totalminDataHeight');
            leftMinValue = _.minBy(basicTables, 'totalminDataWidth');
            this.topMinValue = Math.abs(topMinValue['totalminDataHeight']);
            this.leftMinValue = Math.abs(leftMinValue['totalminDataWidth']);

        }
        let adjustedTopValue = 0;
        let adjustedLeftValue = 0;

        if (this.topMinValue > 50 && this.floorPlanData.ImageId == null) {
            adjustedTopValue = -1 * (this.topMinValue - 30);
        } else if (this.floorPlanData.ImageId) {
        }

        if (this.leftMinValue > 50 && this.floorPlanData.ImageId == null) {
            adjustedLeftValue = -1 * (this.leftMinValue - 30);
        } else if (this.floorPlanData.ImageId) {
        }

        tables.forEach(element => {
            element.Top = element.Top + (element.Height / 2) + adjustedTopValue;
            element.Left = element.Left + (element.Width / 2) + adjustedLeftValue;
        });
        labels.forEach(element => {

            let findstringlength = element.Text.length;
            let getwidth = 11;
            let getHeight = 11;
            let angles = element.Angle;
            if ((angles >= 0 && angles <= 20) || (angles >= 160 && angles <= 200) || (angles >= 340 && angles <= 360)) {
                getwidth = (findstringlength * 10) / 2;
            } else {
                getHeight = (findstringlength * 10) / 2;
            }
            element.Top = element.Top + adjustedTopValue + getHeight;
            element.Left = element.Left + adjustedLeftValue + getwidth;
        });
        walls.forEach(element => {
            element.Points.forEach(point => {
                point['X'] = point['X'] + adjustedLeftValue;
                point['Y'] = point['Y'] + adjustedTopValue;
            });
        });

        shapes.forEach(element => {
            element.Top = element.Top + adjustedTopValue;
            element.Left = element.Left + adjustedLeftValue;
        });

        basicTables = this.findmaxObject(tables, labels, walls, shapes);
        const topValue = _.maxBy(basicTables, 'totalDataHeight');
        const leftValue = _.maxBy(basicTables, 'totalDataWidth');

        this.heightValue = topValue['totalDataHeight'] + 25;
        this.widthValue = leftValue['totalDataWidth'] + 25;
        const height = this.canvasLoader.nativeElement.clientHeight > this.heightValue ? this.canvasLoader.nativeElement.clientHeight : this.heightValue;
        const width = this.canvasLoader.nativeElement.clientWidth > this.widthValue ? this.canvasLoader.nativeElement.clientWidth : this.widthValue;
        let scaleFactor;
        if (this.canvas) {
            this.scaleFactorY = this.canvasLoader.nativeElement.clientHeight / this.heightValue;
            this.scaleFactorX = (this.canvasLoader.nativeElement.clientWidth / this.widthValue > 1) ? 1 : this.canvasLoader.nativeElement.clientWidth / this.widthValue;
            if (this.scaleFactorX < 1 && this.scaleFactorY < 1) {
                scaleFactor = this.scaleFactorX <= this.scaleFactorY ? this.scaleFactorX : this.scaleFactorY;
            }
            else {
                scaleFactor = this.scaleFactorX >= this.scaleFactorY ? this.scaleFactorY : this.scaleFactorX;
            }

            let calculatedWidth = width * scaleFactor;
            //  this.canvas.setZoom(scaleFactor);
            this.canvas.setHeight(this.canvasLoader.nativeElement.clientHeight);
            this.canvas.setWidth(this.canvasLoader.nativeElement.clientWidth);
        }
        let _that = this;
        let floorPlanImage = this.layoutImages.filter(x => x.ImageId == imageId)[0];
        fabric.Image.fromURL(floorPlanImage ? 'data:image/png;base64,' + floorPlanImage.bytes : '', function (img) {
            _that.layoutStyle = { width: img.width + 'px', height: img.height + 'px' }
            _that.canvas.setBackgroundImage(img, _that.canvas.renderAll.bind(_that.canvas), {
                scaleX: _that.canvas.width / img.width,
                scaleY: _that.canvas.height / img.height
            });
        });
        //     //   this.renderer.setStyle(this.canvasLoader.nativeElement, 'height', this.height);
        //     //  this.renderer.setStyle(this.canvasLoader.nativeElement, 'width', this.width)
        tables.forEach(element => {
            this.setTableConfiguration(element);

        });
        this.dataToBePushed.forEach(data => {
            this.canvas.add(data);
            data.set('subTargetCheck', true);
        })

        if (labels) {
            labels.forEach((element, index) => {
                this.addLabel(element, index);
            });

        }
        if (shapes) {
            shapes.forEach(element => {
                this.addShape(element);
            });

        }
        if (walls) {
            walls.forEach(element => {
                this.addWall(element);
            });
        }

        const objs = this.canvas.getObjects();

        objs.forEach((table) => {
            if (table.ImageId && (table.ShapeType == 3 || table.ShapeType == 4)) {
                this.setObjectImage(table);
            }
        });
        //Needed
        if (this.floorPlanData.ImageId) {
            if (this.floorPlanData.Dimensions && this.floorPlanData.Dimensions.length > 0 && this.floorPlanData.Dimensions[0].Width > 0 && this.floorPlanData.Dimensions[0].Height > 0) {
                this.scaleFactorX = this.canvasLoader.nativeElement.clientWidth / this.floorPlanData.Dimensions[0].Width;
                this.scaleFactorY = this.canvasLoader.nativeElement.clientHeight / this.floorPlanData.Dimensions[0].Height;
                this.canvas.getObjects().forEach(element => {
                    element.set({
                        scaleX: element.scaleX * _that.scaleFactorX,
                        scaleY: element.scaleY * _that.scaleFactorY,
                        top: element.top * _that.scaleFactorY,
                        left: element.left * _that.scaleFactorX
                    })
                    element.setCoords();
                });
            }
            else {
                this.scaleObjects(this.canvas, this.scaleFactorX, this.scaleFactorY, scaleFactor, this.floorPlanData.BasedOn)
            }
            // if (isScalingAvailable) {
            //   this.lf.scaleObjects(this.canvas, this.scaleFactorX, this.scaleFactorY, scaleFactor, this.floorPlan.BasedOn);
            // }
        } else {
            this.scaleObjects(this.canvas, this.scaleFactorX, this.scaleFactorY, scaleFactor, this.floorPlanData.BasedOn);
        }
        //this.scaleObjects(this.canvas, this.scaleFactorX, this.scaleFactorY, scaleFactor);
        this.canvas.renderAll();
    }

    findminObject(tables?, labels?, walls?, shapes?) {
        const newtables = _.cloneDeep(tables.map(obj => ({ ...obj, tempname: 'table' })));
        const newlabels = _.cloneDeep(labels.map(obj => ({ ...obj, tempname: 'label' })));
        const newwalls = _.cloneDeep(walls.map(obj => ({ ...obj, tempname: 'wall' })));
        const newshapes = _.cloneDeep(shapes.map(obj => ({ ...obj, tempname: 'area' })));

        const allObjects = _.cloneDeep(newtables.concat(newlabels, newwalls, newshapes));
        allObjects.forEach(element => {
            if (element.tempname == 'wall') {
                const minx = _.minBy(element.Points, (e) => { return e['X']; });
                const miny = _.minBy(element.Points, (e) => { return e['Y']; });
                element.totalminDataHeight = miny['Y'];
                element.totalminDataWidth = minx['X'];
            }
            else if (element.tempname == 'label') {
                const findstringlength = element.Text.length;
                let getwidth = 2;
                let getHeight = 2;
                const angles = element.Angle;
                if ((angles >= 0 && angles <= 20) || (angles >= 160 && angles <= 200) || (angles >= 340 && angles <= 360)) {
                    getwidth = findstringlength / 2;
                } else {
                    getHeight = findstringlength / 2;
                }
                element.totalminDataHeight = element.Top - (getHeight);
                element.totalminDataWidth = element.Left - (getwidth);
            }
            else if (element.tempname == 'table') {
                element.totalminDataHeight = element.Top - ((element.Height / 2) + 14);
                element.totalminDataWidth = element.Left - ((element.Width / 2) + 14);
            } else if (element.tempname == 'area') {
                element.totalminDataHeight = element.Top;
                element.totalminDataWidth = element.Left;
            } else {
                element.totalminDataHeight = element.Top - element.Height;
                element.totalminDataWidth = element.Left - element.Width;
            }
        });

        return allObjects;

    }


    baseElement;
    setCanvas() {
        this.baseElement = this.canvasLoader.nativeElement;
        this.canvas = new fabric.Canvas('tablesLayout', {
            selection: false,
        });
        this.canvas.preserveObjectStacking = true;
        fabric.Object.prototype.set({
            transparentCorners: false,
            rotatingPointOffset: 20,
            cornerSize: 12,
            hasBorders: false,
            lockMovementX: true,
            lockMovementY: true,
            perPixelTargetFind: true,
            flipY: false,
            hasControls: false,
        });

        this.canvas.hoverCursor = 'pointer';
        this.canvas.perPixelTargetFind = true;
        this.canvas.targetFindTolerance = 2;
        let _that = this;

        this.zoomSubs();
        this.canvas.on({
            'mouse:down'(event) {
                if (event.target) {
                    _that.rateplanSupportService.getRateplanData(event.target, _that.currentFromDate, _that.matchedContinousSlots, _that.duration, _that.sizeMapping, _that.restaurantId, null, () => {
                        if (event.target.IsAvailableForBooking && event.target.IsAvailableForReservations) {
                            _that.locationSelection.emit(event.target);
                        }
                        _that.showLocationDetails(event);
                    })
                    // _that.highlightSelectedObject(event.target);
                }else{
                    var evt = event.e;
                    // if (evt.ctrlKey === true) {
                    _that.canvas.isDragging = true;
                    _that.canvas.selection = false;
                    if(evt.type === 'mousedown'){
                        _that.canvas.lastPosX = evt.clientX;
                        _that.canvas.lastPosY = evt.clientY;
                    }
                    if(evt.type === 'touchstart' && evt.touches && evt.touches.length === 1){
                        _that.canvas.lastPosX = evt.touches[0].clientX;
                        _that.canvas.lastPosY = evt.touches[0].clientY;
                    }
                    _that.locationDetail = null;
                }

                if (!(event.target && (event.target.ShapeType === 2 || event.target.ShapeType === 3))) {
                    this.locationDetail = null;
                }

            }
        });
        //     //_that.removeIllusion();


        //   },
        //   'mouse:move'(event) {
        //     if (!_that.isMouseDown) {
        //       _that.removeHightLightColor(event, _that);
        //     }
        //   },
        //   'mouse:up'(event) {
        //     _that.removeHightLightColor(event, _that);

        //   },
        //   'mouse:over'(event) {
        //     _that.showPrice(event, _that)
        //   },
        //   'mouse:out'(event) {
        //     _that.mouseOut(event, _that)
        //   }

        // });

    }

    getWidgetCustomizationData(property) {
        return this.guestService.selectedNonDining.WidgetCustomization && this.guestService.selectedNonDining.WidgetCustomization[property];
    }

    getButtonColor() {
        //return [this.getWidgetCustomizationData('AvailableButtonBackgroundColor') || defaultTheme, this.getWidgetCustomizationData('AvailableButtonColor') || '#fff'];
        return [defaultTheme, '#fff']
    }

    highlightSelectedObject(object) {

        if (object.ShapeType == 2) {
            object._objects.filter(x => x.name == 'shape')[0].set({
                text: '\u2713',
                fill: this.getButtonColor()[0],
                stroke: this.getButtonColor()[0],
                strokeWidth: 2
            });

            object._objects.filter(x => x.name == 'text' || x.name == 'pin')[0].set({
                text: '\u2713',
                fill: this.getButtonColor()[1]
            });
        }
        else {
            object._objects.filter(x => x.name == 'textCircle')[0].set({
                text: '\u2713',
                fill: this.getButtonColor()[0],
                stroke: this.getButtonColor()[0],
                strokeWidth: 2
            });
            object._objects.filter(x => x.name == 'text')[0].set({
                text: '\u2713',
                fill: this.getButtonColor()[1]
            });
        }
    }

    removeHighlightSelectedObject(object) {
        const statusDetail = this.getStatusDetail(object);
        if (object.ShapeType == 2) {
            object._objects.forEach(x => {
                // let shapeC, pinC, textC;
                if (x.name == 'shape') {
                    x.set({
                        text: '\u002B',
                        fill: statusDetail.fill || this.getButtonColor()[0],
                        stroke: statusDetail.fill || this.getButtonColor()[0],
                        strokeWidth: 2
                    })
                } else if ( x.name == 'pin') {
                    x.set({
                        text: '\u002B',
                        fill: statusDetail.fill ? '#fff' : this.getButtonColor()[0]
                    });
                } else if (x.name == 'text') {
                    x.set({
                        text: '\u002B',
                        fill: statusDetail.textColor ? statusDetail.textColor : this.getButtonColor()[0]
                    });
                }
            });

        }
        else {

            object._objects.forEach(x => {
                if (x.name == 'textCircle') {
                    x.set({
                        text: '\u002B',
                        fill: statusDetail.fill || this.getButtonColor()[0],
                        stroke: statusDetail.fill || this.getButtonColor()[0],
                        strokeWidth: 2
                    });
                } else if (x.name == 'text') {
                    x.set({
                        text: '\u002B',
                        fill: statusDetail.textColor ? statusDetail.textColor : this.getButtonColor()[0]
                    });
                }
            });
        }
    }

    findmaxObject(tables?, labels?, walls?, shapes?) {
        const afternewtables = _.cloneDeep(tables.map(obj => ({ ...obj, tempname: 'table' })));
        const afternewlabels = _.cloneDeep(labels.map(obj => ({ ...obj, tempname: 'label' })));
        const afternewwalls = _.cloneDeep(walls.map(obj => ({ ...obj, tempname: 'wall' })));
        const afternewshapes = _.cloneDeep(shapes.map(obj => ({ ...obj, tempname: 'area' })));

        const allObjects = _.cloneDeep(afternewtables.concat(afternewlabels, afternewwalls, afternewshapes));

        allObjects.forEach(element => {
            if (element.tempname == 'wall') {
                const maxx = _.maxBy(element.Points, (e) => { return e['X']; });
                const maxy = _.maxBy(element.Points, (e) => { return e['Y']; });
                element.totalDataHeight = maxy['Y'] + 10;
                element.totalDataWidth = maxx['X'] + 10;
            }
            else if (element.tempname == 'label') {
                const findstringlength = element.Text.length;
                let getwidth = 11;
                let getHeight = 11;
                const angles = element.Angle;
                if ((angles >= 0 && angles <= 20) || (angles >= 160 && angles <= 200) || (angles >= 340 && angles <= 360)) {
                    getwidth = findstringlength * 10.2 / 2;
                } else {
                    getHeight = findstringlength * 10.2 / 2;
                }
                element.totalDataHeight = getHeight + element.Top;
                element.totalDataWidth = getwidth + element.Left;
            }
            else if (element.tempname == 'table') {
                element.totalDataHeight = (element.Height) + element.Top;
                element.totalDataWidth = (element.Width) + element.Left;
            } else if (element.tempname == 'area') {
                element.totalDataHeight = element.Height + element.Top + 15;
                element.totalDataWidth = element.Width + element.Left + 15;
            } else {
                element.totalDataHeight = element.Height / 2 + element.Top;
                element.totalDataWidth = element.Width / 2 + element.Left;
            }

        });

        return allObjects;
    }


    setObjectImage(table) {
        let selectedTableObject = this.canvas.getObjects().filter(tableObj => tableObj.Id == table.Id);
        let tableImage = this.objectImages.filter((img) => img.ImageId == table.ImageId);

        if (selectedTableObject && selectedTableObject.length > 0 && tableImage.length > 0) {
            let compressedPhoto;
            fabric.Image.fromURL('data:image/png;base64,' + tableImage[0].bytes, (img) => {
                compressedPhoto = img;
                let shapedObject = selectedTableObject[0]._objects.filter(ele => ele.name == 'shape')[0];
                if (selectedTableObject[0].ShapeType == 4) {
                    compressedPhoto.set({
                        scaleX: (((shapedObject.width) / img.width) * selectedTableObject[0].scaleX),
                        scaleY: (((shapedObject.height) / img.height) * selectedTableObject[0].scaleY),
                        top: selectedTableObject[0].top,
                        left: selectedTableObject[0].left,
                        originX: 'center',
                        originY: 'center',
                        name: 'image',
                        width: img.width,
                        height: img.height,
                    })
                } else {
                    compressedPhoto.set({
                        scaleX: ((shapedObject.width) / img.width) * selectedTableObject[0].scaleX,
                        scaleY: ((shapedObject.height) / img.height) * selectedTableObject[0].scaleY,
                        top: selectedTableObject[0].top,
                        left: selectedTableObject[0].left,
                        originX: 'center',
                        originY: 'center',
                        name: 'image',
                        width: img.width,
                        height: img.height
                    });
                    let server = selectedTableObject[0]._objects.filter(ele => ele.name == 'serverCircle');
                    if (server && server.length > 0) {
                        server[0].left = server[0].left + 12;
                        server[0].top = server[0].top - 13;
                    }
                }
                let allObjects = selectedTableObject[0]._objects.filter(ele => ele.name == 'textCircle' ||
                    ele.name == 'tableNumber' || ele.name == 'text' || ele.name == 'serverLines').length;

                selectedTableObject[0].addWithUpdate(compressedPhoto);
                if (selectedTableObject[0].ShapeType == 4) {
                    selectedTableObject[0].set({
                        clipPath: new fabric.Circle({
                            radius: selectedTableObject[0].height / 2,
                            originX: 'center',
                            originY: 'center',
                            startAngle: 0,
                            angle: Math.PI * 2,
                        }),
                    })
                }
                compressedPhoto.moveTo(selectedTableObject[0].size() - (allObjects + 1));
                selectedTableObject[0].addWithUpdate();
                this.canvas.renderAll();
            })
        }
    }


    checkTableiscircle(object) {
        const checkdiff = object.Width - object.Height;
        return Math.abs(checkdiff) < 15 ? ShapeTypeEnum.Circle : ShapeTypeEnum.Ellipse;
    }

    addLabel(obj, index) {
        obj.id = index;
        obj.name = 'label';
        this.canvas.add(new fabric.Text(obj.Text.toString(), {
            fontFamily: 'Roboto Light',
            left: obj.Left,
            top: obj.Top,
            fontSize: 20,
            fontWeight: 'bold',
            fill: '#0000008A',
            data: index,
            name: 'label',
            selectable: false,
            angle: obj.Angle,
            originX: 'center',
            originY: 'center'
        }));
        this.canvas.renderAll();
    }
    addShape(element) {
        let shape;
        let newcolor = element.Color ? 'rgba(' + element.Color.R + ',' + element.Color.G + ',' + element.Color.B + ',' + element.Color.A + ')' : '#3B4532'
        if (element.ShapeType != undefined) {
            let type;
            switch (element.ShapeType) {
                case 0:
                    type = ShapeTypeEnum.Rectangle
                    break;
                case 1:
                    type = this.checkTableiscircle(element);
                    break;
                case 2:
                    type = this.checkTableiscircle(element);
                    break
            }
            if (type == ShapeTypeEnum.Rectangle) {
                shape = new fabric.Rect({
                    left: element.Left,
                    top: element.Top,
                    height: element.Height,
                    width: element.Width,
                    stroke: newcolor,
                    strokeWidth: 2,
                    strokeDashArray: [8, 3],
                    name: 'area',
                    fill: '',
                    angle: element.Rotation,
                    selectable: false
                });
            } else if (type == ShapeTypeEnum.Circle) {

                shape = new fabric.Circle({
                    radius: (element.Width > element.Height ? element.Height : element.Width) / 2,
                    left: element.Left,
                    top: element.Top,
                    height: element.Height,
                    width: element.Width,
                    stroke: newcolor,
                    strokeWidth: 2,
                    strokeDashArray: [8, 3],
                    name: 'area',
                    fill: 'transparent',
                    angle: element.Rotation,
                    perPixelTargetFind: true,
                });
            } else if (type == ShapeTypeEnum.Ellipse) {

                shape = new fabric.Ellipse({
                    left: element.Left,
                    top: element.Top,
                    rx: element.Width / 2,
                    ry: element.Height / 2,
                    stroke: newcolor,
                    strokeWidth: 2,
                    strokeDashArray: [8, 3],
                    name: 'area',
                    fill: 'transparent',
                    angle: element.Rotation,
                    perPixelTargetFind: true,
                });

            }
        }
        this.canvas.add(shape)
        this.canvas.sendToBack(shape);
        this.canvas.renderAll();
    }

    addWall(element) {
        element.name = 'wall'
        let linesArray = []
        element.Points.forEach(point => {
            linesArray.push({ x: point.X, y: point.Y })
        });

        let wall = new fabric.Polyline(linesArray, {
            stroke: '#3B4532',
            strokeWidth: 2,
            fill: 'transparent',
            data: element.id,
            name: 'wall',
            perPixelTargetFind: true,

        });
        this.canvas.add(wall)
        this.canvas.sendToBack(wall);
        this.canvas.renderAll();
    }

    setTableConfiguration(element) {
        if (element.ShapeType != undefined) {

            let type;
            switch (element.ShapeType) {
                case 0:
                    type = ShapeTypeEnum.Rectangle
                    break;
                case 1:
                    type = this.checkTableiscircle(element);
                    break;
                case 2:
                    type = ShapeTypeEnum.Pin
                    break;
                case 3:
                    type = ShapeTypeEnum.BasicRectangle;
                    break;
                case 4:
                    type = ShapeTypeEnum.BasicCircle;
                    break;
                case 8:
                    type = ShapeTypeEnum.Image;
                    break;

            }
            let adjustheightval = element.Height;
            let adjustwidthtval = element.Width;
            // const type = 'rect';
            if (type == 'rect') {
                const color = '#f7f7f7';
                const strokeColor = '#95989A';
                const textColor = 'gray';
                const party = null;
                const blocked = false;


                this.rectangle = new fabric.Rect({
                    left: element.Left,
                    top: element.Top,
                    scaleX: this.scaleFactorX,
                    scaleY: this.scaleFactorY,
                    height: adjustheightval,
                    width: adjustwidthtval,
                    fill: '#fff',
                    name: 'shape',
                    rx: 2,
                    ry: 2,
                    scaleFactorX: this.scaleFactorX,
                    scaleFactorY: this.scaleFactorY
                });

                this.rectangle.set({
                    name: 'shape',
                });

                this.tableObj = [];
                this.tableObj.push(this.rectangle);
                this.addTableGroup(this, this.rectangle, element, party);

            }
            else if (type == 'circle') {

                const party = null;

                this.circle = new fabric.Circle({
                    left: element.Left,
                    top: element.Top,
                    height: adjustheightval,
                    width: adjustwidthtval,
                    radius: (adjustwidthtval / 2) > 15 ? (adjustwidthtval / 2) : 15,
                    fill: '#fff',
                });
                this.circle.set({
                    name: 'shape',
                });
                this.addTableGroup(this, this.circle, element, party)
            }
            else if (type == ShapeTypeEnum.Ellipse) {
                this.ellipse = new fabric.Ellipse({
                    left: element.Left,
                    top: element.Top,
                    fill: '#fff',
                    rx: element.Width / 2,
                    ry: element.Height / 2,
                });
                this.ellipse.set({
                    name: 'shape',
                });
                this.ellipse.setControlsVisibility({

                    'ml': false,
                    'mt': false,
                    'mr': false,
                    'mb': false,

                });
                this.addTableGroup(this, this.ellipse, element, false);
            }
            else if (type == ShapeTypeEnum.Pin) {
                let color = '#000';
                let seatingTypeSelected = [];
                if (this.seatingTypeList) {
                    seatingTypeSelected = this.seatingTypeList.filter(x => x.Id == element.SeatingTypeId);
                }

                if (seatingTypeSelected.length > 0) {
                    let statusColor = seatingTypeSelected[0].Color;
                    color = 'rgba(' + statusColor.R + ',' + statusColor.G + ',' + statusColor.B + ',' + statusColor.A + ')';
                }
                this.pin = new fabric.Circle({

                    left: element.Left,
                    top: element.Top,
                    height: adjustheightval,
                    width: adjustwidthtval,
                    radius: (adjustwidthtval / 2) > 15 ? (adjustwidthtval / 2) : 15,
                    fill: color,

                });
                this.pin.set({
                    name: 'shape',
                    type: 'pin'
                });
                this.addTableGroup(this, this.pin, element, false);

            }
            else if (type == ShapeTypeEnum.BasicRectangle) {
                const party = null;
                this.basicRectangle = new fabric.Rect({
                    left: element.Left,
                    top: element.Top,
                    height: adjustheightval,
                    width: adjustwidthtval,
                    fill: '#fff',
                    rx: 2,
                    ry: 2
                });

                this.basicRectangle.set({
                    name: 'shape',
                    type: 'brect'
                });
                this.addTableGroup(this, this.basicRectangle, element, false);
            } else if (type == ShapeTypeEnum.BasicCircle) {
                const party = null;
                this.basicCircle = new fabric.Circle({
                    left: element.Left,
                    top: element.Top,
                    height: adjustheightval,
                    width: adjustwidthtval,
                    radius: (adjustwidthtval / 2) > 15 ? (adjustwidthtval / 2) : 15,
                    fill: '#fff',
                });
                this.basicCircle.set({
                    name: 'shape',
                    type: 'bcircle'
                });
                this.addTableGroup(this, this.basicCircle, element, false)
            }
            else if (type == ShapeTypeEnum.Image) {
                const images = this.customImages.filter((img) => img.ImageId == element.ImageId);
                if (images && images.length == 1) {
                    let that = this;
                    fabric.Image.fromURL('data:image/png;base64,' + images[0].bytes, function (img) {
                        img.set({
                            scaleX: (adjustwidthtval / img.width) * that.scaleFactorX,
                            scaleY: (adjustheightval / img.height) * that.scaleFactorY,
                            top: element.Top * that.scaleFactorY,
                            left: element.Left * that.scaleFactorX,
                            name: 'shape',
                            type: 'image',
                            scaleFactorX: that.scaleFactorX,
                            scaleFactorY: that.scaleFactorY
                        })
                        that.addTableGroup(that, img, element, false);
                    });
                }
            }

        }
    }



    addTableGroup(that, object, element, party) {
        let blocked = false;
        that.tableObj = [];
        const statusColorData = this.getStatusColor(element);
        const statusDetail = this.getStatusDetail(element);
        if (object.type == ShapeTypeEnum.Pin) {
            object.set('fill', statusDetail.fill);
        } else {
            object.set('fill', '#d3d3d3');
        }

        element.tableColor = this.getStatusDetail(element)?.fill;

        if (object.type == ShapeTypeEnum.Image) {

            object.set('stroke', this.getButtonColor()[0]);
            object.set('strokeWidth', 2);
        }

        that.tableObj.push(object);
        that.groupedObject = new fabric.Group(that.tableObj, {
            top: object.top,
            left: object.left,
            originY: 'center',
            originX: 'center',
        });

        let seatingTypeSelected = [];//**this.ls.restaurantWidgetSettings$.value.SeatingTypeList.filter(x => x.Id == element.SeatingTypeId);
        let color = statusDetail.fill || 'white'
        // if (seatingTypeSelected.length > 0) {
        //     let statusColor = seatingTypeSelected[0].Color;
        //     color = 'rgba(' + statusColor.R + ',' + statusColor.G + ',' + statusColor.B + ',' + statusColor.A + ')';
        // }
        that.groupedObject.set({
            SeatingArea: element.SeatingArea,
            SeatingAreaId: element.SeatingAreaId,
            SeatingType: element.SeatingType,
            SeatingTypeId: element.SeatingTypeId,
            ServerId: element.ServerId,
            MaxPartySize: element.MaxPartySize,
            MinPartySize: element.MinPartySize,
            Name: element.Name,
            Price: element.Price || 0,
            IsAvailableForBooking: element.IsAvailableForBooking,
            IsAvailableForReservations: element.IsAvailableForReservations,
            IsCommunalTable: element.IsCommunalTable,
            FloorPlanViewId: element.FloorPlanViewId,
            Id: element.Id,
            ShapeType: element.ShapeType,
            Party: statusColorData.partyData,
            selectable: !element.IsAvailableForReservations || !element.IsAvailableForBooking || element.MinPartySize > 2/*this.partyDetails.partySize*/ ? false : true,
            radius: element && element.radius > 0 ? element.radius : object.width / 2,
            Angle: element ? element.RotationAngle : 0,
            defaultColor: color,
            ImageId: element ? element.ImageId : null,
            tableColor: element.tableColor

        });
        // if (!element.IsAvailableForReservations || !element.IsAvailableForBooking || element.MinPartySize > 2/*this.partyDetails.partySize*/) {
        //     color = '#7d7d7d';
        //     object.set({
        //         selectable: false,
        //         fill: 'red',
        //         opacity: 1
        //     });
        //     that.groupedObject.set({
        //         defaultColor: '#7d7d7d'
        //     })
        // }
        if (object.type == 0 || object.type == ShapeTypeEnum.Rectangle) {
            const seatData = this.drawRectangleSeat(that.groupedObject, that, '#3B4532');
            seatData.forEach(seat => {
                seat.set('strokeWidth', seat.strokeWidth * that.groupedObject.scaleX)
                that.groupedObject.addWithUpdate(seat);
                seat.moveTo(that.groupedObject.size() - 5)
            });
        }
        else if (object.type == 1 || object.type == ShapeTypeEnum.Circle) {
            const obj = _.cloneDeep(that.groupedObject)
            const seatData = this.drawCircleSeat(obj, that, '#3B4532');
            seatData.forEach(seat => {
                that.groupedObject.addWithUpdate(seat);
                seat.moveTo(that.groupedObject.size() - 5)
            });
        }

        that.groupedObject.setCoords();
        let text1;
        text1 = new fabric.Text(statusDetail.text, {
            fill: statusDetail.textColor,
            textAlign: 'center',
            fontSize: object.scaleFactorX ? 14 * object.scaleFactorX : 14,
            fontWeight: 600,
            originX: 'center',
            originY: 'center',
            name: 'text',
            top: that.groupedObject.top,
            left: that.groupedObject.left,
        });

        const numberCircle = new fabric.Circle({
            fill: statusDetail.fill || '#fff',
            radius: object.scaleFactorX ? 14 * object.scaleFactorX : 14,
            top: that.groupedObject.top,
            left: that.groupedObject.left,
            originX: 'center',
            originY: 'center',
            name: 'textCircle',
            opacity: .8,
            stroke: statusDetail.stroke,
            strokeWidth: object.scaleFactorX ? 2 * object.scaleFactorX : 2
        });
        if (object.type == ShapeTypeEnum.Pin) {
            text1 = new fabric.Text(statusDetail.text, {
                textAlign: 'center',
                fill: statusDetail.textColor || '#fff',
                name: 'pin',
                top: that.groupedObject.top,
                left: that.groupedObject.left,
                originX: 'center',
                originY: 'center',
                fontWeight: 'bold',
                objectCaching: false,
                fontSize: object.radius
            });
        }
        if (object.type != ShapeTypeEnum.Pin) {
            that.groupedObject.addWithUpdate(numberCircle);
        }

        that.groupedObject.addWithUpdate(text1)

        if (element) {
            that.groupedObject.rotate(element.RotationAngle);
        }
        that.groupedObject.addWithUpdate();

        if (element && element.scaleX) {
            let tempScaleX = element.scaleX;

            if (tempScaleX == 0 || tempScaleX < 0.1) {
                tempScaleX = 1;
                that.groupedObject.set({
                    scaleX: tempScaleX
                })
            }

        }

        if (element && element.scaleY) {
            let tempScaleY = element.scaleY;

            if (tempScaleY == 0 || tempScaleY < 0.1) {
                tempScaleY = 1;
                that.groupedObject.set({
                    scaleY: tempScaleY
                })
            }

        }

        if (object.type == ShapeTypeEnum.Image) {
            if (element && element.Angle) {
                that.groupedObject.set({
                    angle: element.Angle
                })
            }
        }

        that.groupedObject.setCoords();
        that.count++;
        that.canvas.add(that.groupedObject);

    }



    drawRectangleSeat(obj, that, colorData) {
        const color = '#444444';
        const objectWidth = obj.width;
        const objectHeight = obj.height;
        let setArray;
        const partySize = obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize;
        switch (partySize) {
            case 1:
                setArray = ['left'];
                break;
            case 2:
                setArray = ['left', 'right'];
                break;
            case 3:
                setArray = ['left', 'top', 'right'];
                break;
            case 4:
                setArray = ['left', 'top', 'right', 'bottom'];
                break;
            case 5:
                setArray = ['left', 'top-right', 'top-left', 'right', 'bottom'];
                break;
            case 6:
                setArray = ['left', 'top-right', 'top-left', 'right', 'bottom-left', 'bottom-right'];
                break;
            default:
                break;
        }

        return this.drawSeat(obj, setArray, this, color);
    }


    drawSeat(obj, seatArray, that, color) {
        const tableObj = [];
        const scale = obj._objects.filter(x => x.name == 'shape')[0].scaleX;
        const shape = obj._objects.filter(x => x.name == 'shape')[0]
        seatArray.forEach(element => {
            switch (element) {
                case 'top': {
                    const ff = this.rectSeat(obj.left - (obj.width / 4), (obj.top - (obj.height / 2) - 6), obj.left + (obj.width / 4), (obj.top - (obj.height / 2) - 6), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'left': {
                    const ff = this.rectSeat((obj.left - (obj.width / 2) - 4), (obj.top - (obj.height / 4) - 4), (obj.left - (obj.width / 2) - 4), (obj.top + obj.height / 4), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'right': {
                    const ff = this.rectSeat((obj.left + (obj.width / 2) - 1), (obj.top - (obj.height / 4) - 4), (obj.left + (obj.width / 2) - 1), (obj.top + obj.height / 4), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'bottom': {
                    const ff = this.rectSeat((obj.left - (obj.width / 4)), (obj.top + (obj.height / 2)), obj.left + (obj.width / 4), (obj.top + (obj.height / 2)), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'top-right': {
                    const ff = this.rectSeat(obj.left + (obj.width / 8), (obj.top - (obj.height / 2) - 6), obj.left + (obj.width / 2) - (obj.width / 8), (obj.top - (obj.height / 2) - 6), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'top-left': {
                    const ff = this.rectSeat(obj.left - (obj.width / 2) + (obj.width / 8), (obj.top - (obj.height / 2) - 6), obj.left - (obj.width / 8), (obj.top - (obj.height / 2) - 6), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'bottom-right': {
                    const ff = this.rectSeat(obj.left + (obj.width / 8), (obj.top + (obj.height / 2)), obj.left + (obj.width / 2) - (obj.width / 8), (obj.top + (obj.height / 2)), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'bottom-left': {
                    const ff = this.rectSeat(obj.left - (obj.width / 2) + (obj.width / 8), (obj.top + (obj.height / 2)), obj.left - (obj.width / 8), (obj.top + (obj.height / 2)), scale, color);
                    tableObj.push(ff);
                    break;
                }
                case 'top-right': {
                    const ff = this.rectSeat(obj.left + (obj.width / 2) + (obj.width / 8), (obj.top - 6), obj.left + (obj.width) - (obj.width / 8), (obj.top - 6), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'top-left': {
                    const ff = this.rectSeat(obj.left + (obj.width / 8), (obj.top - 6), obj.left + (obj.width / 2) - (obj.width / 8), (obj.top - 6), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'bottom-right': {
                    const ff = this.rectSeat(obj.left + (obj.width / 2) + (obj.width / 8), (obj.top + (obj.height)), obj.left + (obj.width) - (obj.width / 8), (obj.top + (obj.height)), scale, color);
                    tableObj.push(ff);
                    break;
                }

                case 'bottom-left': {
                    const ff = this.rectSeat(obj.left + (obj.width / 8), (obj.top + (obj.height)), obj.left + (obj.width / 2) - (obj.width / 8), (obj.top + (obj.height)), scale, color);
                    tableObj.push(ff);
                    break;
                }
            }

        });
        return tableObj;
    }


    rectSeat(x1, y1, x2, y2, scale, color) {
        scale = 1;
        const rectangleSeatObj = new fabric.Line([x1, y1, x2, y2], {
            stroke: color,
            strokeWidth: (5),
        });
        rectangleSeatObj.set({
            name: 'seat'
        });
        return rectangleSeatObj;
    }


    drawCircleSeat(obj, that, colorData) {
        const color = '#444444';
        const seatWidth = 5 * 5;
        const radius = obj.radius;
        return this.roundSeatDraw(obj.MaxPartySize > 6 ? 6 : obj.MaxPartySize, radius, color, this.getButtonColor()[0], this, obj, color); // green,blue
    }

    roundSeatDraw(seat, radius, seatColor, tblFillColor, that, obj, color?) {
        const seatWidth = seat * 25;
        const lastend = 0;
        const myTotal = seat * 8;
        let startAngle = 0;
        const tableObj1 = [];
        const strokeColor = '';
        const table = obj._objects.filter(x => x.name == 'shape')[0];
        for (let i = 0; i < seat; i++) {
            const circleSeat = new fabric.Circle({
                radius: ((table.width * table.scaleX) / 2) + 3,
                startAngle: startAngle - ((Math.PI * 2) / myTotal),
                endAngle: startAngle + ((Math.PI * 2) / myTotal),
                stroke: seatColor,
                strokeWidth: (5),
                fill: '',
                top: obj.top,
                left: obj.left,
                originX: 'center',
                originY: 'center',
            });

            circleSeat.set({
                name: 'seat',
            });

            startAngle += Math.PI * 2 * ((myTotal / seat) / myTotal);
            tableObj1.push(circleSeat);
        }
        return tableObj1;
    }

    getStatusDetail(element) {
        if (element.IsAvailableForBooking && element.IsAvailableForBooking) {
            let seatingTypeSelected = {} as any;
            if (this.seatingTypeList) {
                seatingTypeSelected = this.seatingTypeList.find(x => element.SeatingTypeId === x.Id);
            }

            //seatingTypeSelected &&  && (!this._selectedSeatingType ||  this._selectedSeatingType === element.SeatingTypeId)
            if (seatingTypeSelected) {
                let statusColor = seatingTypeSelected.Color;
                let color = 'rgba(' + statusColor.R + ',' + statusColor.G + ',' + statusColor.B + ',' + statusColor.A + ')';

                return { ...this.masterStatusData.selectable, fill: color, textColor: '#fff', stroke: color }
            }
            return this.selectedSeatingType ? this.masterStatusData.notSelectable : this.masterStatusData.selectable;
        }else{
            return this.masterStatusData.soldout;
        }
    }

    getStatusColor(element) {
        let fillColor = '#7d7d7d';
        const textColor = '#444444';
        let partyColor = 'black';
        let stroke = '#3B4532';
        let numberColor = '#4f483e';
        let partyData = null;
        return ({ fillColor, textColor, partyData, partyColor, stroke, numberColor });
    }

    scaleObjects(canvas, scaleFactorX, scaleFactorY, scaleFactor, BasedOn?) {
        const objects = canvas.getObjects();
        for (const i in objects) {
            const scaleX = objects[i].scaleX;
            const scaleY = objects[i].scaleY;
            const left = objects[i].left;
            const top = objects[i].top;
            const shapetype = objects[i].name == 'area';
            let scalefactorneed = false;
            if (objects[i]._objects) {
                let shape = objects[i]._objects.filter(x => x.name == 'shape')[0];
                let shapetypetable = shape.get('type');
                scalefactorneed = false;
                if (!shapetype && shapetypetable == ShapeTypeEnum.Rectangle && BasedOn == undefined) {
                    scalefactorneed = this.getbigRectangle(objects[i].width, objects[i].height);
                }
            }
            const tempScaleX = scaleX * (shapetype || scalefactorneed ? scaleFactorX : scaleFactor);
            const tempScaleY = scaleY * (shapetype || scalefactorneed ? scaleFactorY : scaleFactor);
            const tempLeft = left * scaleFactorX;
            const tempTop = top * scaleFactorY;
            if (objects[i].points) {

                objects[i].scaleX = scaleFactorX;
                objects[i].scaleY = scaleFactorY;
                objects[i].left = tempLeft;
                objects[i].top = tempTop;
            } else {
                objects[i].scaleX = tempScaleX;
                objects[i].scaleY = tempScaleY;
                objects[i].left = tempLeft;
                objects[i].top = tempTop;
            }
            objects[i].setCoords();
        }
        canvas.renderAll();
        canvas.calcOffset();
    }


    getbigRectangle(Width, Height) {
        const checkdiff = Width < Height;
        let finalval = Height / Width;
        if (!checkdiff) {
            finalval = Width / Height;
        }
        return Math.abs(finalval) > (1.25);
    }

    getLayoutData(restaurantId: Number, partySize: Number, isCommunalTable: boolean, timeSlot, seatingAreaId = null, seatingTypeId = null, reservationIdToIgnore = null) {
        seatingTypeId = null;
        return this.httpService.get(`${urlConfig.layoutUrl}?restaurantId=${restaurantId}&timeSlot=${timeSlot}&partySize=${partySize}&showCommunalTable=${isCommunalTable}&seatingareaid=${seatingAreaId}&reservationIdToIgnore=${reservationIdToIgnore}&seatingtypeid=${seatingTypeId}`);
    }

}

const defaultTheme = '#2196f3';
const highlightColor = '#61ff00';